var _defs, _path, _path2, _ellipse, _circle, _circle2, _circle3, _circle4, _ellipse2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCat = function SvgCat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1372.51 1275.32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".class-1{fill:#e6e7e8}.class-2,.class-7{fill:#231f20}.class-2{opacity:.07}.class-3{fill:#fff}.class-4{fill:#58595b}.class-8{fill:#8b5e3c}.class-9{fill:#30664e}.class-10{fill:#25543e}.class-11{fill:#f5d7ce}.class-15{fill:#f8e6e3}.class-16{fill:#f6dfdb}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    id: "cattail",
    fill: "freeze",
    className: "class-1 cattail",
    d: "M159.77 363.07c154.31.77 236.07-111.9 390-42.25a92.81 92.81 0 0 1 17.86 11l51.25-51.25C498.76 189.41 328.35 260.36 276 280c-53.5 20-176.26 49.59-176.64-8.9S271 266.1 271 147.58c0-92.35-115.06-86.2-113.52-53.87s25.4 15.39 35.79 18.47c12.73.77 35.73 13.82 33.08 36.94s-33.09 35.4-118.14 45.41S5.47 362.3 159.77 363.07Z",
    transform: "translate(-13.74 -62.34)"
  }, /*#__PURE__*/React.createElement("animate", {
    dur: "3s",
    repeatCount: "indefinite",
    attributeName: "d",
    values: "M159.77,363.07c154.31,0.77,236.07-111.9,390-42.25a92.81,92.81,0,0,1,17.86,11l51.25-51.25C498.76,189.41,328.35,260.36,276,280,222.5,300,99.74,329.59,99.36,271.1S271,266.1,271,147.58c0-92.35-115.06-86.2-113.52-53.87s25.4,15.39,35.79,18.47C206,112.95,229,126,226.35,149.12s-33.09,35.4-118.14,45.41S5.47,362.3,159.77,363.07Z; M165.77,365.07c154.31,0.77,226.07-121.9,390-38.23a82.81,92.81,0,0,1,13.86,11l51.25-51.25C498.76,189.41,318.35,250.36,266,285,222.5,290,94.74,330.59,81.36,270.1S271,267.1,242,112.58c0-62.25-113.06-90.2-110.52-71.87s23.4,35.39,5.79,28.47C206,82.95,190,125,197.35,144.12s-33.09,35.4-118.14,45.41S5.47,362.3,150.77,363.07Z; M159.77,363.07c154.31,0.77,236.07-111.9,390-42.25a92.81,92.81,0,0,1,17.86,11l51.25-51.25C498.76,189.41,328.35,260.36,276,280,222.5,300,99.74,329.59,99.36,271.1S271,266.1,271,147.58c0-92.35-115.06-86.2-113.52-53.87s25.4,15.39,35.79,18.47C206,112.95,229,126,226.35,149.12s-33.09,35.4-118.14,45.41S5.47,362.3,159.77,363.07Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "class-1",
    d: "M625.78 286.11q-3.42-2.85-6.91-5.51l-51.25 51.25C630 381.67 627.43 513 565 447.73c-67.92-71-114.67-86.39-188.17-77.92s-112.36 50.41-137 128.91-37.9 48.1-39.83 37.71 5.39-28.28-4-33.86-36.36 6.35-51.76 27.9c-4.81 3.27-12.89-4-31.17-3.08s-34.12 8.15-42.65 4.75c0 0-18.6-28-39.25-28-9.24 0-6.41 30.78-12.19 53.36S4.89 644 40.1 677.84s94 60.41 113.26 156.62c0 0 25.65 179.32 19.5 202s-31.17 22.32-30.4 33.48 4.62 12.31 18.47 12.31h40S234 1013.39 245.2 931s17.32-88.89 25.78-88.89 30 142.38 23.86 196.64c-3.46 20.39-3.08 19.63-9.24 24.24s-3.46 19.24-3.46 19.24h42.71s20.78-48.49 26.94-145.84 28.86-230.11 81.58-230.11 3.08 84.27 1.92 125.83 23.09 200.48 9.24 219.72-22.7 14.62-20 30.4h55.8L515 852.55s.77-12.31 11.16-12.31 7.7 15 8.08 20.78 1.64 181.24 0 187-6.21 16.55-13.52 17.7c-5.39 4.23-1.54 16.55-1.54 16.55h45a338.57 338.57 0 0 0 18.86-80c5-45.41 29.63-216.65 33.48-236.27s36.17-154.31 49.64-190.09 80.06-189.37-40.38-289.8Z",
    transform: "translate(-13.74 -62.34)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "class-2",
    cx: 629.58,
    cy: 1016.69,
    rx: 603.03,
    ry: 5.66
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "cat-left-eye",
    className: "cat-left-eye class-3",
    cx: 62.48,
    cy: 538.81,
    r: 13.38
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "cat-left-eyeball",
    className: "cat-left-eyeball class-4",
    cx: 62.48,
    cy: 538.81,
    r: 8.35
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "cat-right-eye",
    className: "cat-right-eye class-3",
    cx: 133.58,
    cy: 538.81,
    r: 13.38
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "cat-right-eyeball",
    className: "cat-right-eyeball class-4",
    cx: 133.58,
    cy: 538.81,
    r: 8.35
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#efbeb4"
    },
    d: "M86.67 554.28h21.31l-10.66 16.63-10.65-16.63z"
  }), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "class-2",
    cx: 854.87,
    cy: 1098.06,
    rx: 259.38,
    ry: 15.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "class-2",
    d: "M1246.09 1073.78s4.34-1.38 5.37 2.25 1.38 7.26-31.13 7.09-72.81 1.56-78.17 1.56-78.37.69-46.36-11.16M1059.47 1239s13.85-9 22.7-1.63 21.38 13.67 30.21 11.69 25.85 2.37 25.27 9.77-17.06 17-43.35 13.27-70.12 1.9-63.63-4.81 7.57-34.29 28.8-28.29ZM1125.09 1229.85c-3.26 5.18-5.13 7.64 5.13 9.44s10.73 1.93 18.65 0 10.73-6.6 4.2-10.09-15.93 3.18-19.66.94-8.32-.29-8.32-.29Z",
    transform: "translate(-13.74 -62.34)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.07
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "class-7",
    d: "m941.45 1219.72 1.74 1.61a2 2 0 0 0-1.74-1.61ZM947 1224.89l-3.83-3.56c3.94 13.29-54.61 104-80.14 106.63V1317l-132.8-56.6a39.56 39.56 0 0 0-.17 8.85c.48 4.62 59.54 33.63 80.42 38.69s52.52 29.72 52.52 29.72c27.34-2.85 98-110.87 84-112.77Z",
    transform: "translate(-13.74 -62.34)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "class-8",
    d: "M1205.74 1057.24c10.5-3.33 14.41-4.08 31.6 5.27s5.66 16.82-.84 17.93-62.6.72-62.6.72-27.09-1.67-35.6.35-31.64-2.69-36.88-.82-12.34-12.35 7.68-17 38.38-15.31 52.09-10.59 31.11 4.35 33.16 2.22M775 715.84s-33.75-4.57-45.82-.57-42.78 3.25-67.6 5.28c-11.67 1-6.36 36.29-57.46 22-22.19-6.22-17.86 36.86-19.62 39.66-3.29 5.24 6.81 31.06 6.81 31.06L615 906.95l35.12 74.83 71.35-52.61 58.72-116.9 14.4-63.11Z",
    transform: "translate(-13.74 -62.34)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "class-2",
    d: "M245.63 1212s1.5 24.32-25.15 25.17-27.06-3.6-25.16-7.75M453.6 1168.49s33.46-3.67 20 16-177.65 41-159.14 3.29M1172.61 1186.61s-27.58 18.66 26.68 26.51 139.32 11 169.13 7.31 13.23-13.2 13.23-13.2",
    transform: "translate(-13.74 -62.34)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "class-9 Leaf1",
    d: "M661.53 720.56s-53.39-57.08-85.75-48-59.19 38.83-67.82 169-20.7 338.06-85.38 347.55-109.81 8-111.82 2.87-1.46-20.71 60.72-42.25a9.9 9.9 0 0 0 5.37-4.41c21.21-37.09 38-139.53 40.27-164.63 2.3-25.87 19-359.91 172.22-356.46 70.44 2.3 120.42 94.41 120.42 94.41Z",
    transform: "translate(-13.74 -62.34)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "class-9 Leaf3",
    d: "M692.57 693s-19-178-20.75-237.84S654 239 667.8 237.88s79.95 208.22 97.74 481.34h-71.87Z",
    transform: "translate(-13.74 -62.34)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "class-9 Leaf4",
    d: "M756.52 617.1s51.68-342.32 113-458.4 67.33-122.7 63.63-44.36-112.89 563.77-112.89 604.87H752Z",
    transform: "translate(-13.74 -62.34)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "class-9",
    d: "M821.93 701.35s79.43-162.61 89.78-178.14 22.92-46.58 30.31-31.79 5 117.2-48.27 227.8h-86Z",
    transform: "translate(-13.74 -62.34)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "class-9 Leaf6",
    d: "M916.1 665.67s117.81-53.35 166 31c47.16 82.54 52 277.22-51.21 420.43a2.91 2.91 0 0 1-5.25-2.1c9.88-65.9 54.32-391.57-29.92-409.63-32.14-4-70.05 15.55-70.05 15.55l-39.38-1.74Z",
    transform: "translate(-13.74 -62.34)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "class-9 LeafFalling",
    d: "M1383.95 1204.4c-9.05-20.63-108.23-49.52-211.71-62.47-17.42-1.56 2.34 52.25 26 62.13s190.49 11.22 185.71.34Z",
    transform: "translate(-13.74 -62.34)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "class-9",
    d: "M247 1204.07s-9.73 25.81-26.93 26.93-30.67-1.5-31-3.37 14.54-43.39 57.93-23.56Z",
    transform: "translate(-13.74 -62.34)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "class-10",
    d: "M525.33 646.28a36.75 36.75 0 0 1 12.37-8.41l5.6 56.72s-5.74 4.39-11.12 18.76c.01.01-8.91-39.35-6.85-67.07ZM916.1 665.67a132.89 132.89 0 0 1 19.9-6.51l-7.5 59.92-2.81 1.92-31.94-1.74Z",
    transform: "translate(-13.74 -62.34)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "class-10",
    d: "m742.77 554.76 9.02-55.21 29.07 157.33h-29.07l-9.02-102.12z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "class-11",
    d: "m644.42 960.86-10.07-9.56-11.07-55.86-12.08-57.88-11.58-48.31-9.55-35.25 3-16.61-5-18.32h-23.36a10.5 10.5 0 0 0-10.38 12.08L608 1084a101.45 101.45 0 0 0 100.3 86.2h133.32a101.45 101.45 0 0 0 100.3-86.2l51.89-341.14a20.65 20.65 0 0 0-20.42-23.76H775l-7.73 23.86-14.09 33.22-10.07 41.77-7 24.16-13.59 21.64-15.1 22.14-2 10.07-24.66 33.72Z",
    transform: "translate(-13.74 -62.34)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.43,
      fill: "#231f20"
    },
    d: "m605.28 851.72 9.18 61.5 20.58-18.46-6.11-5.8-11.07-55.86-12.08-57.88-11.58-48.32-9.56-35.23 2.22-12.18h-2.74l-6.02 3.63-3.24 4.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m575.83 835.16-15.77-103.69a10.77 10.77 0 0 1 10.65-12.39",
    transform: "translate(-13.74 -62.34)",
    style: {
      opacity: 0.23,
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m624.05 968.09 3.87 58.82 22.86 21.09 8.09 77.08s8.79 42 26.82 43.6",
    transform: "translate(-13.74 -62.34)",
    style: {
      fill: "none",
      stroke: "#f9f0ef",
      strokeMiterlimit: 10,
      strokeWidth: "3.81px"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "class-15",
    d: "M732.88 1254.91a39.51 39.51 0 0 0-.17 8.85c.48 4.62 59.54 33.63 80.42 38.69s52.54 29.68 52.54 29.68v-20.62Z",
    transform: "translate(-13.74 -62.34)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "class-2",
    d: "m532.43 1167.45 66.21-44.74s86.52 31 96.9 35.08l1.11 12.3s-76.59-20.09-164.22-2.64Z",
    transform: "translate(-13.74 -62.34)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "class-9 Leaf2",
    d: "M619.85 630.9s-51.52-57.49-82.13-20.83S539.59 741 552.24 791.6s66.12 201.8 42 223.07S365.45 652.46 525 564.5c66.91-30.5 140.16 58.62 153 110.09l-52.72-26.15Z",
    transform: "translate(-13.74 -62.34)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "class-2",
    d: "m523.57 1170.53 6.52 10.44s21.73-6.09 40.55-5.22 43-1.36 54.55 0 58.42 11 58.42 11l13-16.68s-17.14-1.89-18.1-1.42-93.42-18.31-93.42-18.31Z",
    transform: "translate(-13.74 -62.34)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "class-16",
    d: "m669.87 1121.34 13.04-13.6-6.28-5.47h-8.45l-3.38.98 5.07 18.09z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "class-15",
    d: "m523.57 1167.45 6.52 10.44s21.73-6.09 40.55-5.22 43-1.36 54.55 0 58.42 11 58.42 11l-1.93-11.83s-2.17-6.74-3.14-6.27-93.42-18.31-93.42-18.31Z",
    transform: "translate(-13.74 -62.34)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "class-11",
    d: "m523.57 1167.45-2.41-3.32 77.49-41.42s81.35 37.8 91.73 41.91l-8.69 7.24s-70.49-21.86-158.12-4.41Z",
    transform: "translate(-13.74 -62.34)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "class-11 Clay2",
    d: "M737.23 1225.75s96.71-10.2 103.69-4.8 4.76 4.8 4.76 4.8 84.43-13.37 98.4-11.47-51.1 105.38-78.4 108.24c0 0-8.57-12.38-20.63-17.14s-104.11-48.88-110.15-47.93 2.33-31.7 2.33-31.7Z",
    transform: "translate(-13.74 -62.34)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "class-16",
    d: "M944.08 1214.19c14 1.9-51.1 105.38-78.4 108.24v9.7c27.3-2.86 97.94-110.87 84-112.77ZM932.05 1164.29l7.14-18.41 4.13 5.87s-8.25 21.11-8.41 23.17Z",
    transform: "translate(-13.74 -62.34)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "class-2",
    d: "m928.9 1161.14 7.14-18.41-21.24-26.16c-1.59 0-22.22 18.73-24.76 22.38s-21.43 22.36-21.43 22.36l1.72 19.58 41.71-6Z",
    transform: "translate(-13.74 -62.34)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "class-15",
    d: "m918.31 1101.95 2.85 10.64H897.2l-36.19 5.39v-12.87l19.52-6.17 24.45-1.43 10.31.63 3.02 3.81z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "class-11",
    d: "m939.19 1145.88-7.14 18.41s-20.47-1.75-23.17-1.27-19.52 3-23.49 3.33-10.63 1.1-10.63 1.1 18.89-18.71 21.43-22.36 23.17-22.38 24.76-22.38Z",
    transform: "translate(-13.74 -62.34)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "class-2",
    d: "m1001.34 1195.07-21.5 7.17s-14.57-4.28-17.75-5.18-15.55-3-17.93-3.43-7.64-.48-8.11-1-6.39-16.93-6.39-16.93l-13.8-41.54 12-3.38 19.47-3.62v49.33Z",
    transform: "translate(-13.74 -62.34)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "class-16",
    d: "m984.94 1200.34 2.77-6.41s2.95-6.6 3.58-6.6 17-8.25 18.89-8.25 42.38-6.19 42.38-6.19h6l1.09 3.64-3.12 8.9-6 1.19-6.51.71-7.78-.71-13.91 2.46-22.75 6.51-6 1.75Z",
    transform: "translate(-13.74 -62.34)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "class-15",
    d: "m987.71 1193.93-2.77 6.41s-15.55-5.51-18.73-6.41-15.55-3-17.93-3.43-6.51-.48-7-1-6.39-13.81-6.39-13.81l-13.45-41.58 6-3.33 24 45.71Z",
    transform: "translate(-13.74 -62.34)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "class-11",
    d: "M939.19 1165.51s4.81 10.44 5.39 12.57c0 0 21.08 4.25 24 6.57s17 9.48 19.14 9.28 18.37-9.48 22.82-9.67 18.76-4.83 21.85-4.54 5.22.32 7.54.6 19.72-3.79 19.72-3.79-6.57-23.26-13.15-31.45-12-17.66-12.18-20.18a37.52 37.52 0 0 1 .77-7.35l-7-3.48s-16.82 6.38-24.56 6.38-28.43 1.8-31.91 2.25-44.12 8.3-44.12 8.3Z",
    transform: "translate(-13.74 -62.34)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m570.15 835.16-15.78-103.69A10.77 10.77 0 0 1 565 719.08h23l5 18.32-3 16.61 9.56 35.23 11.58 48.31 12.08 57.88 11.07 55.86 10.07 9.56L623.79 985l-13.09-71-40.56-78.89",
    transform: "translate(-13.74 -62.34)",
    style: {
      fill: "#f9f0ef"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "class-8",
    d: "M494.61 1224.76s7.35-17.95 22.25-11.46 19.48 4.12 25.21 2.06 17.76 23.52 9.45 27-35.42 9.41-41.15 8.14-17.57-13.87-17.57-13.87ZM561.34 1231.87c4.86-2 16.22-4.95 19.13 0s0 10.77-3.49 12.81-10.77-.58-14 0-1.64-12.81-1.64-12.81Z",
    transform: "translate(-13.74 -62.34)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "class-8",
    d: "M578.75 1240.35c2.66-1.11 8.85-2.7 10.44 0a5.31 5.31 0 0 1-1.91 7c-1.91 1.11-5.88-.32-7.63 0s-.9-7-.9-7ZM1061.41 1236s13.85-9 22.7-1.63 21.38 13.67 30.21 11.69 25.85 2.37 25.27 9.77-17.06 17-43.35 13.27-70.12 1.9-63.63-4.81 7.57-34.29 28.8-28.29ZM1125.75 1229.16c-3.26 5.18-5.13 7.64 5.13 9.44s10.73 1.93 18.65 0 10.73-6.6 4.2-10.09-15.93 3.19-19.66.94-8.32-.29-8.32-.29Z",
    transform: "translate(-13.74 -62.34)"
  })));
};
export default SvgCat;